module.exports = __webpack_public_path__ + "e582c44e3ffd53f1f4ef499f56b04408.MP3";